import {
  LineButtonTypeBubble,
  LineButtonTypeBubbleProps,
  ButtonTypeCardProps,
} from './LineButtonTypeBubble';
import { LineImageTypeBubble, LineImageTypeBubbleProps } from './LineImageTypeBubble';
import { LineRichMessageBubble, LineRichMessageBubbleProps } from './LineRichMessageBubble';

export const LineMessageBubble = {
  ButtonType: LineButtonTypeBubble,
  ImageType: LineImageTypeBubble,
  RichMessage: LineRichMessageBubble,
};

export type {
  LineButtonTypeBubbleProps,
  LineImageTypeBubbleProps,
  LineRichMessageBubbleProps,
  ButtonTypeCardProps,
};
